module.exports = __webpack_public_path__ + "img/pwa-install-popup-btn.39fe4398.png";